import React, { SVGProps } from "react"

function BigCaretRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 41 230"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.826 229.662H.175L23.822 115 .175.338h15.65L40.18 115 15.826 229.662z"
        fill="currentColor"
      />
    </svg>
  )
}

export default BigCaretRight
